import { SectionCard } from '@/shared/ui'
import s from './BookingNotesCard.module.css'

/**
 * Секция «Примечание к брони» — `BookingDetail.internalNotes`.
 *
 * ⚠️ ЭТО НЕ ПДн ГОСТЯ, И ПРАВА `bookings.guests.view` ЗДЕСЬ НЕТ. Так сказано доменом дословно у
 * поля 22 `BookingView`: заметки О ГОСТЕ живут в другом месте (`guest_pii.guest_notes`) и приходят
 * только с этим правом. Спутав их, мы либо спрятали бы от менеджера обычное рабочее примечание,
 * либо — что хуже — показали бы без права то, что защищено. Поэтому у секции нет и не должно быть
 * никакой проверки права: она показывает то, что видно всем, у кого есть доступ к брони.
 *
 * ⚠️ ТЕКСТ ЧУЖОЙ И НЕДОВЕРЕННЫЙ — его пишет площадка (из RealtyCalendar сюда попадают состав
 * гостей и пожелания по заезду). Отсюда две вещи в вёрстке, обе намеренные:
 *
 *   • он рисуется ТОЛЬКО как текст — React экранирует его сам, и ни разметки, ни ссылок из него
 *     мы не собираем: «сделать ссылку из того, что похоже на адрес» означало бы разбирать чужую
 *     строку и однажды увести менеджера не туда;
 *   • переносы строк сохраняются (`pre-wrap`), а слово без пробелов рвётся (`anywhere`). Первое —
 *     потому что состав гостей приезжает построчно и без переносов слипнется в кашу; второе —
 *     потому что чужая строка может не иметь пробелов вовсе, и тогда она растянула бы карточку.
 */
export function BookingNotesCard({ notes }: { notes: string }) {
  return (
    <SectionCard className={s.card} eyebrow="Примечание к брони">
      <div className={s.body}>
        <p className={s.text}>{notes}</p>
      </div>
    </SectionCard>
  )
}
